export enum UpdateAction {
    ADD = "ADD",
    REMOVE = "REMOVE"
}